'use client'
import { gtagEvent } from 'lib/gtag'
import { BlockUI } from 'primereact/blockui'
import { Checkbox } from 'primereact/checkbox'
import { ProgressSpinner } from 'primereact/progressspinner'
import { useState } from 'react'
import UploadFile from './UploadFile'

const OnboardingForm = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const [step, setStep] = useState(1)
  const [skipInsertMenu, setSkipInsertMenu] = useState(false)
  const [formFocussed, setFormFocussed] = useState(false)

  const createMenuRequest = async (e?) => {
    setLoading(true)
    console.log('%c e', 'color:#FFB86C', e)
    // Assuming `event.files` is an array of file objects.
    const files = e ? e.files : []

    // Create an instance of FormData
    const formData = new FormData()

    // Loop through each file and append it to the FormData
    files.forEach((file) => {
      formData.append('file', file) // Use 'files' as the key for the files
    })

    // Add other form data (name, email, phone number)
    formData.append('name', name) // Replace 'Your Name Here' with the actual name variable
    formData.append('email', email) // Replace with the actual email variable
    formData.append('phone', phone) // Replace with the actual phone number variable

    // Now formData can be sent via a fetch POST request or another method to your server
    try {
      const response = await fetch('https://api.meamenu.com/mea-api/public/restaurant/form', {
        method: 'POST',
        body: formData,
        // When using FormData, do not set Content-Type; the browser will do it for you
      })

      if (response.ok) {
        console.log('Files and data uploaded successfully')
      } else {
        console.error('Failed to upload files and data')
      }
      setLoading(false)
      setSubmitted(true)
    } catch (error) {
      console.error('Error:', error)
      setLoading(false)
    }
  }

  const captureFirstFormFocus = () => {
    if (!formFocussed) {
      setFormFocussed(true)
      gtagEvent({
        event: 'click',
        category: 'Onboarding',
        label: 'Onboarding form focus',
        value: 1,
      })
    }
  }

  return (
    <BlockUI blocked={loading}>
      {loading && (
        <div className="progress-spinner">
          <ProgressSpinner pt={{ root: { className: 'static' } }} animationDuration="20s" />
        </div>
      )}
      {submitted ? (
        <div className="flex flex-col items-center p-4 text-center shadow-[1px_3px_26px_3px_rgba(0,0,0,0.1)]">
          <p className="text-lg leading-7 text-gray-500 dark:text-gray-400">
            Tutto pronto! Verrai ricontattato via email o telefono per ricevere il tuo menu.
          </p>
          <button
            className="btn mt-3 flex items-center rounded-xl bg-secondary px-3 py-3 text-base font-medium leading-6 text-white hover:bg-secondary-500 dark:bg-primary dark:text-black dark:hover:bg-primary-200"
            onClick={() => {
              setStep(1)
              setSubmitted(false)
              setSkipInsertMenu(false)
            }}
          >
            Torna indietro per digitalizzare un altro menu
          </button>
        </div>
      ) : (
        <div className="rounded-xl p-4 shadow-[1px_3px_26px_3px_rgba(0,0,0,0.1)]">
          {step === 1 && (
            <form
              className="flex flex-col items-center space-y-3"
              onSubmit={() => {
                setStep(2)
                gtagEvent({
                  event: 'click',
                  category: 'Onboarding',
                  label: 'Submit step 1 form',
                  value: 1,
                })
              }}
              onFocus={captureFirstFormFocus}
            >
              <input
                autoComplete="name"
                className="w-full rounded-md p-3 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-secondary-300 dark:bg-black dark:focus:ring-primary-600 md:w-1/2"
                id="name-input"
                name="name"
                placeholder="Nome del tuo ristorante"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                type="text"
              />
              <input
                autoComplete="email"
                className="w-full rounded-md p-3 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-secondary-300 dark:bg-black dark:focus:ring-primary-600 md:w-1/2"
                id="email-input"
                name="email"
                placeholder="La tua email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                type="email"
              />
              <input
                autoComplete="tel"
                className="w-full rounded-md p-3 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-secondary-300 dark:bg-black dark:focus:ring-primary-600 md:w-1/2"
                id="phone-input"
                name="phone"
                placeholder="Il tuo numero di telefono (opzionale)"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                type="tel"
              />
              <div className="flex flex-col items-center p-4 text-center">
                <button
                  type="submit"
                  className="btn mt-3 flex items-center rounded-xl bg-secondary px-3 py-3 text-base font-medium leading-6 text-white hover:bg-secondary-500 dark:bg-primary dark:text-black dark:hover:bg-primary-200"
                >
                  Digitalizza il tuo menu
                </button>
              </div>
            </form>
          )}

          {step === 2 && (
            <>
              <div className="justify-center pb-2 text-center">
                <p className="text-2xl leading-7 text-gray-500 dark:text-gray-400 ">
                  Ci sei quasi! Inserisci le immagini che rappresentano il tuo menu
                </p>
                <div className="p-4 text-gray-500 dark:text-gray-400">
                  <Checkbox
                    inputId="skipInsertMenu"
                    name="skipInsertMenu"
                    value="true"
                    onChange={(e) => setSkipInsertMenu(!skipInsertMenu)}
                    checked={skipInsertMenu}
                  />
                  <label htmlFor="skipInsertMenu" className="ml-2">
                    Lo farò in un altro momento
                  </label>
                </div>

                {skipInsertMenu && (
                  <div className="flex justify-center pb-4 text-center text-gray-500 dark:text-gray-400">
                    <button
                      onClick={() => createMenuRequest()}
                      className="btn mt-3 flex items-center rounded-xl bg-secondary px-3 py-3 text-base font-medium leading-6 text-white hover:bg-secondary-500 dark:bg-primary dark:text-black dark:hover:bg-primary-200"
                    >
                      Avanti
                    </button>
                  </div>
                )}
              </div>
              <BlockUI blocked={skipInsertMenu}>
                <UploadFile onSubmit={createMenuRequest} />
              </BlockUI>
            </>
          )}
        </div>
      )}
    </BlockUI>
  )
}

export default OnboardingForm
